import {Component} from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">DUCK ADMIN <i class="fa fa-copyright" aria-hidden="true"></i> {{ currentYear }}</span>
  `,
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
